import React from 'react'
import Header  from '../../components/Header'
import DocumentTitle from 'react-document-title'
import  './invite.less'
import { isWeChat, jumpApp,imageUrl } from '../../utils/utils'
import wx from 'weixin-js-sdk'

export default class VipInvite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {}

  handleRecord = () => {
    // if(isWeChat() == 3 || isWeChat() == 4) {
      jumpApp({opentype:'invite_list', openvar: '3'})
    // } else {
    //   wx.miniProgram.navigateTo({url: '/pages/vip/records/records'})
    // }
  }

  handleShare = () => {
    // if(isWeChat() == 3 || isWeChat() == 4) {
      // jumpApp({opentype:'invite_share', openvar: ''})
    // } else {
    //   wx.miniProgram.navigateTo({url: '/path/to/page'})
    // }
  }

  goQuestion = (sex) => {
    this.props.history.push("/survey/question?sex=" + sex);
  }

  render() {
    return (
    <DocumentTitle title="邀请有礼">
      <article>
        <div className="vip-invite-container" style={{backgroundImage:`url(${imageUrl('/201811/5498968d7afb5b85262b0adf32a4dfa9.png')})`}}>
            <div className="record" onClick={this.handleRecord}>
              邀请记录
            </div>
            <div className="button-container" onClick={this.handleShare}>
              <div className="button">
                您来晚了哦，活动已结束
              </div>
              {/* <img src="http://huhuapp-images.huhustory.com/open/Public/Uploads/201811/724d5d7db68be802b093f153a0eadab1.gif" alt="http://huhuapp-images.huhustory.com/open/Public/Uploads/201811/724d5d7db68be802b093f153a0eadab1.gif" /> */}
            </div>
        </div>
      </article>
    </DocumentTitle>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/vip/invite.js